import SvgIcon from '@/assets/svgIcon';

interface Props {
  src?: string;
  width?: number;
  height?: number;
}

export const ProfileAvatar = ({ src, width = 40, height = 40 }: Props) => {
  return (
    <div className="flex h-10 min-w-10 items-center justify-center rounded-full border-[1px] border-solid border-[#ececec] bg-[#fbfbfb]">
      {src ? (
        <img src={src} width={width} height={height} alt="프로필 이미지" />
      ) : (
        <SvgIcon width={24} height={24} name="defaultUserIcon" />
      )}
    </div>
  );
};
